import { render, staticRenderFns } from "./AspireTeacherPrep2023.vue?vue&type=template&id=d50f51b0&scoped=true"
import script from "./AspireTeacherPrep2023.vue?vue&type=script&lang=js"
export * from "./AspireTeacherPrep2023.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d50f51b0",
  null
  
)

export default component.exports